// const dev = process.env.NODE_ENV === 'production'
//rak1hwBn
 export const SERVER = 'https://fecavolley.cybexai-server.com/api/v1/'
//export const SERVER = 'http://localhost:3300/api/v1/'
